import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Loader2, Upload } from 'lucide-react';

interface PromptPublishButtonProps {
  currentVersion: number | null;
  hasChanges: boolean;
  onPublish: () => Promise<void>;
  isPublishing: boolean;
}

export function PromptPublishButton({
  currentVersion,
  hasChanges,
  onPublish,
  isPublishing,
}: PromptPublishButtonProps) {
  const [showConfirm, setShowConfirm] = useState(false);

  const nextVersion = (currentVersion ?? 0) + 1;

  const handlePublish = async () => {
    await onPublish();
    setShowConfirm(false);
  };

  return (
    <>
      <Button
        onClick={() => setShowConfirm(true)}
        disabled={!hasChanges || isPublishing}
        className="w-full sm:w-auto"
      >
        <Upload className="h-4 w-4 mr-2" />
        Publicar v{nextVersion}.0
      </Button>

      <AlertDialog open={showConfirm} onOpenChange={setShowConfirm}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Publicar Versão {nextVersion}.0?</AlertDialogTitle>
            <AlertDialogDescription>
              As alterações no rascunho serão publicadas como uma nova versão.
              {currentVersion && (
                <>
                  {' '}A versão {currentVersion}.0 será desativada e arquivada no histórico.
                </>
              )}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={isPublishing}>Cancelar</AlertDialogCancel>
            <AlertDialogAction
              onClick={handlePublish}
              disabled={isPublishing}
            >
              {isPublishing && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
              Publicar Agora
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
